import { useTranslations } from "use-intl";

import { Badge } from "@lawline/ui/components/badge";
import { cn } from "@lawline/ui/core/cn";

import type { WebhookDeliveryStatus } from "../webhooks.types";

const STATUS_CLASS: Record<WebhookDeliveryStatus, string> = {
	pending: "bg-sky-500/15 text-sky-700 dark:text-sky-400",
	succeeded: "bg-emerald-500/15 text-emerald-700 dark:text-emerald-400",
	failed: "bg-destructive/15 text-destructive",
	cancelled: "bg-muted text-muted-foreground",
};

export function WebhookDeliveryStatusBadge({ status }: { status: WebhookDeliveryStatus }) {
	const t = useTranslations("webhooks.deliveries.status");
	return <Badge className={cn("border-transparent", STATUS_CLASS[status])}>{t(status)}</Badge>;
}
